module.exports = __webpack_public_path__ + "img/No-Upcoming-Events.62354df5.png";